import { createContext, useContext, useEffect } from 'react'

/**
 * How a Settings section tells the page it holds unsaved edits, so switching
 * sections or leaving the page asks first instead of silently dropping them.
 * The key is the section id, or `<section>:<part>` when one section has
 * several independent editors.
 */
export const SettingsUnsavedChanges = createContext<
  (section: string, dirty: boolean) => void
>(() => undefined)

export function useReportUnsavedChanges(section: string, dirty: boolean) {
  const report = useContext(SettingsUnsavedChanges)
  useEffect(() => {
    report(section, dirty)
    return () => report(section, false)
  }, [report, section, dirty])
}
